/**
 * @license
 * Copyright 2023 Nuraly, Laabidi Aymen
 * SPDX-License-Identifier: MIT
 */

export * from './tabs.component.js';
export * from './tabs.types.js';

// For backward compatibility - will be removed in next major version
export { NrTabsElement as TabsComponent } from './tabs.component.js';
